import React from "react";
import PropTypes from "prop-types";
import { Table, Spin, Grid, Tag } from "antd";

const { useBreakpoint } = Grid;

const AlertReportTable = ({ loading, data }) => {
  const screens = useBreakpoint();

  const columns = [
    {
      title: "Counter Code",
      dataIndex: "counterCode",
      key: "counterCode",
      sorter: true,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      sorter: true,
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      sorter: true,
    },
    {
      title: "Article Name",
      dataIndex: "article",
      key: "article",
      sorter: true,
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      sorter: true,
    },
    {
      title: "Threshold",
      dataIndex: "threshold",
      key: "threshold",
      sorter: true,
    },
    {
      title: "Current Quantity",
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      sorter: true,
      render: (qty, record) => {
        if (qty === null || qty === undefined || isNaN(qty)) {
          return <Tag color="default">N/A</Tag>;
        }

        const isWarning = qty <= record.threshold;
        return (
          <Tag color={isWarning ? "red" : "green"}>
            {qty} {isWarning ? "(Low)" : ""}
          </Tag>
        );
      },
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        padding: screens.xs ? "10px" : "20px",
      }}
    >
      <Spin spinning={loading} tip="Loading alert data...">
        <Table
          columns={columns}
          dataSource={data}
          rowKey="_id"
          pagination={{ pageSize: screens.xs ? 5 : 10 }}
          scroll={screens.xs ? { x: "max-content" } : undefined}
        />
      </Spin>
    </div>
  );
};

AlertReportTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array.isRequired,
};

export default AlertReportTable;
